/** Compact colored badge for a 0-100 research score. */

import React from "react";

interface ScoreBadgeProps {
  score: number | string;
  label?: string;
}

function toneFor(score: number): { bg: string; text: string } {
  if (score >= 75) return { bg: "bg-signal-teal/15", text: "text-signal-teal" };
  if (score >= 50) return { bg: "bg-signal-amber/15", text: "text-signal-amber" };
  if (score >= 25) return { bg: "bg-signal-rose/10", text: "text-signal-rose" };
  return { bg: "bg-signal-rose/20", text: "text-signal-rose" };
}

export default function ScoreBadge({ score, label }: ScoreBadgeProps): React.ReactElement {
  // Scores arrive as Decimals serialized to strings over JSON, so coerce
  // before any numeric method call to avoid a render crash.
  const value = Number(score);
  const safe = Number.isFinite(value) ? value : 0;
  const tone = toneFor(safe);
  const isHigh = safe >= 75;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${tone.bg} ${tone.text} ${isHigh ? "ring-1 ring-signal-teal/30" : ""}`}
    >
      {label && <span className="font-normal text-mist-400">{label}</span>}
      {safe.toFixed(0)}
    </span>
  );
}
